import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice, createApi } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/redux-injectors";
import { ReportIssueState } from "./types";
import { baseQuery, endpoints, formatErrors } from "utils/api/endpoints";


export const initialState: ReportIssueState = {
    isLoading: false,
    error: null,
    data: null,
};

 export const api = createApi({
  reducerPath: "reportIssueApi",
  baseQuery,
  tagTypes: ["ReportIssue"],
  endpoints: (builder) => ({
    reportIssue: builder.mutation<any, any>({
      query: (body) => ({
        url: endpoints.reportIssue.url,
        method: endpoints.reportIssue.method,
        body: body,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    // table history
    getReportHistory: builder.query<any, any>({
      query: () => ({
        url: endpoints.reportIssue.url,
        method: endpoints.reportIssue.method,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }), 
  }),
 })



const slice = createSlice({
  name: "reportIssue",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const { actions: Actions } = slice;

export const useReportIssueSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  
  return {
    actions: slice.actions,
    ...api,
  };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
